// extracted by mini-css-extract-plugin
export default {"container":"supplier-list_container__QQnGK","header":"supplier-list_header__tb8y5","supplier":"supplier-list_supplier__9WkAY"};